// extracted by mini-css-extract-plugin
export default {"container":"LineSeparator__container___gnhmE"};